// extracted by mini-css-extract-plugin
export var content = "_e2-3";
export var list = "_e2-4";
export var settingsContent = "_e2-7";
export var settingsPanel = "_e2-8";
export var state = "_e2-6";
export var triggerBadge = "_e2-2";
export var triggerButton = "_e2-1";
export var triggerShell = "_e2-0";
export var unreadDot = "_e2-5";